export const SET_GALLERY_INDEX = 'SET_GALLERY_INDEX';
